"use strict";
// src/sui-sdk/client.ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCustomSuiClient = void 0;
exports.getSuiNodeUrl = getSuiNodeUrl;
exports.getSuiClient = getSuiClient;
exports.setSuiNodeUrl = setSuiNodeUrl;
exports.setSuiClient = setSuiClient;
/* This file contains the setup for the Sui Client, implemented as a singleton
 */
const client_1 = require("@mysten/sui/client");
const stsui_sdk_1 = require("@alphafi/stsui-sdk");
// Lazy initialization for the SuiClient instance
let suiClientInstance = undefined;
let suiNodeUrl = undefined;
/**
 * Get the current Sui node URL.
 * If no URL has been set, it defaults to the mainnet full node URL.
 */
function getSuiNodeUrl() {
    suiNodeUrl = suiNodeUrl ? suiNodeUrl : (0, client_1.getFullnodeUrl)("mainnet");
    return suiNodeUrl;
}
/**
 * Get the SuiClient instance.
 * If a new URL has been set via setSuiNodeUrl, it will create a new instance with the updated URL.
 */
function getSuiClient(rpcNodeUrl) {
    if (rpcNodeUrl) {
        setSuiNodeUrl(rpcNodeUrl);
    }
    if (!suiClientInstance) {
        const nodeUrl = getSuiNodeUrl();
        suiClientInstance = new client_1.SuiClient({
            url: nodeUrl,
        });
    }
    return suiClientInstance;
}
/**
 * Set a new Sui node URL.
 * This will invalidate the current SuiClient instance, ensuring that
 * the next call to getSuiClient returns a new instance with the updated URL.
 *
 * @param rpcNodeUrl - The new RPC URL for the Sui client.
 */
function setSuiNodeUrl(rpcNodeUrl) {
    (0, stsui_sdk_1.setSuiNodeUrl)(rpcNodeUrl);
    if (suiNodeUrl !== rpcNodeUrl) {
        suiNodeUrl = rpcNodeUrl;
        suiClientInstance = undefined; // Invalidate the current instance to allow creating a new one
    }
}
/**
 * Set a new SuiClient instance with the specified RPC node URL.
 * This function directly creates a new instance of the SuiClient, overriding the existing instance
 * and using the provided URL for future requests.
 *
 * If the RPC node URL is different from the currently stored URL, a new instance of SuiClient will
 * be created and assigned, allowing the client to communicate with a new Sui node.
 *
 * @param rpcNodeUrl - The new RPC URL to be used for the SuiClient.
 */
function setSuiClient(rpcNodeUrl) {
    (0, stsui_sdk_1.setSuiClient)(rpcNodeUrl);
    if (suiNodeUrl !== rpcNodeUrl) {
        suiNodeUrl = rpcNodeUrl;
        suiClientInstance = new client_1.SuiClient({
            url: rpcNodeUrl,
        });
    }
}
/**
 * Set a custom SuiClient instance.
 * This function directly assigns the provided SuiClient instance to the global variable,
 * allowing for direct manipulation of the client instance.
 *
 * @param suiClient - The custom SuiClient instance to be set.
 */
const setCustomSuiClient = (suiClient) => {
    (0, stsui_sdk_1.setCustomSuiClient)(suiClient);
    suiClientInstance = suiClient;
};
exports.setCustomSuiClient = setCustomSuiClient;
//# sourceMappingURL=client.js.map